import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withState, withHandlers, withProps } from 'recompose';
import { get, find } from 'lodash';
import { withRouter } from 'react-router-dom';
import { categories } from '../categories/_api';
import { withStyles } from '@material-ui/core/styles';
import withLoader from '../../modules/app/withLoader';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import {
  Grid,
  Table,
  TableHeaderRow,
  PagingPanel,
  TableFilterRow,
  TableColumnReordering,
  DragDropProvider,
  TableRowDetail,
} from '@devexpress/dx-react-grid-material-ui';
import {
  SortingState,
  IntegratedSorting,
  PagingState,
  IntegratedPaging,
  FilteringState,
  IntegratedFiltering,
  RowDetailState,
  DataTypeProvider,
} from '@devexpress/dx-react-grid';
import Paper from '@material-ui/core/Paper';
import { getCategory } from '../categories/_api';
import { listProducts, updateCategoryConfig, getItemReservations } from './_api';
import { getReservation, getArchivedReservation } from '../reservations/_api';
import { setActiveCategory } from '../app/_api';
import { without } from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ChevronRight from '@material-ui/icons/ChevronRight';
import moment from 'moment';
import { itemStatus } from '../../utils/constants';

const DateFormatter = ({ value }) => moment(value).format('DD.MM.YYYY, HH:mm:ss');

const DateTypeProvider = (props) => (
  <DataTypeProvider formatterComponent={DateFormatter} {...props} />
);

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  iconButton: {
    padding: 0,
  },
});

const enhance = compose(
  withStyles(styles),
  withState('categories', 'setCategories', []),
  withState('category', 'setCategory', []),
  withState('columnOrder', 'setColumnOrder', []),
  withState('items', 'setItems', []),
  withState('reservations', 'setReservations', []),
  withState('expandedRowIds', 'setExpandedRowIds', []),
  withState('filters', 'setFilters', []),
  withRouter,
  withLoader,
  connect((state) => ({ activeCategory: get(state, 'app.activeCategory', 'BEZKY') }), {
    setActiveCategory,
  }),
  withHandlers({
    loadItems:
      ({ setItems }) =>
      async (categoryId) => {
        const products = await listProducts(categoryId);
        if (products) {
          let gridItems = [];
          get(products, 'items', []).map((product) => {
            get(product, 'items', []).map((item) => {
              gridItems.push({
                product: { ...product, items: undefined },
                ...item,
              });
              return '';
            });
            return '';
          });
          setItems(gridItems);
        }
      },
    loadCategoryAndOrder:
      ({ setCategory, setColumnOrder }) =>
      async (categoryId) => {
        const cat = await getCategory(categoryId);
        setCategory(cat);
        const colOrder = get(cat, 'config.attributesOrder', []);
        if (colOrder.length === get(cat, 'attributes', []).length) {
          setColumnOrder(
            without(
              [...colOrder.map((item) => `${get(item, 'id', null)}`), 'price', 'serialNumber'],
              'null'
            )
          );
        } else {
          setColumnOrder(
            without(
              [
                ...get(cat, 'attributes', []).map((item) => `${get(item, 'id', null)}`),
                'price',
                'serialNumber',
                'status',
              ],
              'null'
            )
          );
        }
      },
    loadReservations: () => async (id) => {
      const resp = await getItemReservations(id);
      return resp;
    },
    redirectToReservation:
      ({ history }) =>
      async (id, archived = false) => {
        history.push(`/reservations/${id}?archived=${archived}`);
      },
  }),
  lifecycle({
    async componentDidMount() {
      const { setCategories, toggleLoader, activeCategory, loadCategoryAndOrder, loadItems } =
        this.props;
      toggleLoader();
      const resp = await categories();
      if (resp) {
        setCategories(resp.items);
        await loadCategoryAndOrder(activeCategory);
        await loadItems(activeCategory);
      }
      toggleLoader(false);
    },
  }),
  withHandlers({
    redirectTo:
      ({ history }) =>
      async (id) => {
        history.push(`/products/${id}`);
      },

    TableRowExpanded:
      ({ redirectToReservation }) =>
      ({ row, ...restProps }) =>
        (
          <Table.Row
            {...restProps}
            style={{
              cursor: 'pointer',
              ':hover': { background: '#7eb6e4' },
            }}
            onClick={() => redirectToReservation(get(row, 'id'), get(row, 'archived', false))}
          />
        ),
  }),
  withProps(() => ({
    detailColumns: [
      { name: 'id', title: 'ID rezervace' },
      {
        name: 'user',
        title: 'Jméno',
        getCellValue: (row) => `${get(row, 'user.surname', '')} ${get(row, 'user.forename', '')}`,
      },
      { name: 'from', title: 'Od' },
      { name: 'to', title: 'Do' },
      { name: 'createdDate', title: 'Vytvořeno' },
    ],
  })),
  withHandlers({
    redirectToUser:
      ({ history }) =>
      (id) => {
        history.push(`/users/${id}`);
      },
    TabContainer: () => (props) => {
      return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
          {props.children}
        </Typography>
      );
    },
    handleTabChange:
      ({
        setActiveCategory,
        toggleLoader,
        loadCategoryAndOrder,
        loadItems,
        setReservations,
        setExpandedRowIds,
        setFilters,
      }) =>
      async (event, categoryId) => {
        toggleLoader();
        setActiveCategory(categoryId);
        await loadCategoryAndOrder(categoryId);
        await loadItems(categoryId);
        setReservations([]);
        setExpandedRowIds([]);
        toggleLoader(false);
        setFilters([]);
      },
    columns:
      ({ category }) =>
      () => {
        const output = get(category, 'attributes', []).map((item) => ({
          name: `${item.id}`,
          title: item.name,
          getCellValue: (row) => {
            let atts = [];
            if (item.level === 1) {
              // atributy z produktu
              atts = get(row, 'product.attributes', []);
            }
            if (item.level === 4) {
              // atributy z itemu
              atts = get(row, 'attributes', []);
            }
            const att = find(atts, { attributeId: item.id });
            return get(att, 'value', '');
          },
        }));
        return [
          ...output,
          { name: 'price', title: 'Pořizovací cena' },
          { name: 'serialNumber', title: 'Sériové číslo' },
          {
            name: 'status',
            title: 'Stav',
            getCellValue: (row) => get(find(itemStatus, { id: row.status }), 'label'),
          },
        ];
      },

    TableRow:
      ({ redirectTo }) =>
      ({ row, ...restProps }) =>
        (
          <Table.Row
            {...restProps}
            style={{
              cursor: 'pointer',
            }}
            onClick={() => {
              redirectTo(get(row, 'productId'));
            }}
          />
        ),
    RowDetail:
      ({ detailColumns, reservations, TableRowExpanded }) =>
      ({ row }) => {
        return (
          <Paper>
            <Grid
              rows={get(find(reservations, { id: row.id }), 'reservations', [])}
              columns={detailColumns}
            >
              <DateTypeProvider for={['createdDate', 'from', 'to']} />
              <Table rowComponent={TableRowExpanded} />
              <TableHeaderRow />
            </Grid>
          </Paper>
        );
      },

    TableComponent:
      ({ classes }) =>
      (props) =>
        <Table.Table {...props} className={classes.gridTable} />,
    ToggleCellComponent:
      ({ classes, loadReservations, reservations, setReservations, toggleLoader }) =>
      ({ expanded, onToggle, row, ...otherProps }) => {
        const handleClick = async (e) => {
          e.stopPropagation();
          console.log(row);
          onToggle();
          if (!expanded) {
            toggleLoader();
            const resp = await loadReservations(row.id);
            const allRes = [
              ...get(resp, 'actualReservations', []).map((item) => ({ id: item, archived: false })),
              ...get(resp, 'futureReservations', []).map((item) => ({ id: item, archived: false })),
              ...get(resp, 'pastReservations', []).map((item) => ({ id: item, archived: true })),
            ];

            await Promise.all(
              allRes.map((res) =>
                res.archived ? getArchivedReservation(res.id, false) : getReservation(res.id, false)
              )
            ).then((result) =>
              setReservations([...reservations, { id: row.id, reservations: result }])
            );
            toggleLoader(false);
          }
        };
        return (
          <Table.Cell {...otherProps}>
            <div onClick={handleClick}>
              <IconButton classes={{ root: classes.iconButton }}>
                {expanded ? <ExpandMore /> : <ChevronRight />}
              </IconButton>
            </div>
          </Table.Cell>
        );
      },
    changeColumnOrder:
      ({ category, setColumnOrder, toggleLoader }) =>
      async (values) => {
        toggleLoader();
        const order = without(values, 'serialNumber', 'price').map((item, i) => ({
          id: item,
          order: i + 1,
        }));
        const resp = await updateCategoryConfig(category.id, order);
        if (get(resp, 'attributesOrder', false)) {
          setColumnOrder(
            without(
              [
                ...resp.attributesOrder.map((item) => `${get(item, 'id', null)}`),
                'price',
                'serialNumber',
              ],
              'null'
            )
          );
        }
        toggleLoader(false);
      },
  })
);

export default enhance(
  ({
    classes,
    activeCategory,
    TabContainer,
    handleTabChange,
    categories,
    columns,
    items,
    TableRow,
    columnOrder,
    changeColumnOrder,
    RowDetail,
    ToggleCellComponent,
    expandedRowIds,
    setExpandedRowIds,
    filters,
    setFilters,
    reservations,
  }) => (
    <div className={classes.root}>
      {console.log(reservations)}
      <Tabs value={activeCategory} onChange={handleTabChange} scrollable scrollButtons="auto">
        {categories.map((item) => (
          <Tab key={item.id} label={item.name} value={item.id} />
        ))}
      </Tabs>
      <TabContainer>
        <Paper>
          <div className="grid--clickable grid--custom">
            <Grid rows={items || []} columns={columns()}>
              <FilteringState filters={filters} onFiltersChange={setFilters} />
              <SortingState defaultSorting={[]} />
              <PagingState defaultCurrentPage={0} defaultPageSize={25} />
              <IntegratedFiltering />
              <IntegratedSorting />
              <IntegratedPaging />
              <RowDetailState
                expandedRowIds={expandedRowIds}
                onExpandedRowIdsChange={setExpandedRowIds}
              />
              <DragDropProvider />
              <Table rowComponent={TableRow} />
              <TableHeaderRow showSortingControls />
              <TableRowDetail
                contentComponent={RowDetail}
                toggleCellComponent={ToggleCellComponent}
                toggleColumnWidth={60}
              />
              <TableFilterRow />
              <TableColumnReordering order={columnOrder} onOrderChange={changeColumnOrder} />
              <PagingPanel pageSizes={[10, 25, 50, 0]} />
            </Grid>
          </div>
        </Paper>
      </TabContainer>
    </div>
  )
);



// WEBPACK FOOTER //
// ./src/modules/items/index.js